module.exports = __webpack_public_path__ + "assets/img/1_1664_big.27e9b59e.jpg";